import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 1.72 3.64',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M1.49,3.36H.24A.23.23,0,0,1,0,3.13V1.28A.36.36,0,0,1,.36.92h1a.36.36,0,0,1,.36.36V3.13A.23.23,0,0,1,1.49,3.36ZM.36,1a.24.24,0,0,0-.24.24V3.13a.11.11,0,0,0,.12.11H1.49a.11.11,0,0,0,.11-.11V1.28A.24.24,0,0,0,1.36,1Z"
        />
        <path
          fill={fill}
          d="M1.36,3.36A.06.06,0,0,1,1.3,3.3V1.86a.1.1,0,0,0-.09-.11H.51a.1.1,0,0,0-.09.11V3.3a.06.06,0,0,1-.06.06A.06.06,0,0,1,.3,3.3V1.86a.23.23,0,0,1,.21-.23h.7a.22.22,0,0,1,.21.23V3.3A.06.06,0,0,1,1.36,3.36Z"
        />
        <path
          fill={fill}
          d="M1.25,1A.05.05,0,0,1,1.19,1V.24A.13.13,0,0,0,1.07.12H.66A.12.12,0,0,0,.54.24V1A.06.06,0,0,1,.48,1,.05.05,0,0,1,.42,1V.24A.24.24,0,0,1,.66,0h.41a.24.24,0,0,1,.24.24V1A.06.06,0,0,1,1.25,1Z"
        />
        <path
          fill={fill}
          d="M.23,3.64a.06.06,0,0,1-.06-.06V3.3a.06.06,0,0,1,.06-.06.06.06,0,0,1,.06.06v.28A.06.06,0,0,1,.23,3.64Z"
        />
        <path
          fill={fill}
          d="M1.49,3.64a.06.06,0,0,1-.06-.06V3.3a.06.06,0,0,1,.12,0v.28A.06.06,0,0,1,1.49,3.64Z"
        />
        <path
          fill={fill}
          d="M.86,2.32A.18.18,0,1,1,1,2.14.18.18,0,0,1,.86,2.32Zm0-.24a.06.06,0,1,0,0,.12.06.06,0,1,0,0-.12Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
